var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserQa',{attrs:{"showDialog":_vm.dialogQa,"userId":_vm.authMod.user.user.id},on:{"confirmed":_vm.onQaConfirmed,"cancelled":_vm.onQaCancelled}})
}
var staticRenderFns = []

export { render, staticRenderFns }